import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const HOME = { admin: "/admin/dashboard", technician: "/technician", user: "/dashboard" };

export default function ProtectedRoute({ children, adminOnly = false, technicianOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="font-display text-2xl text-slate-500">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to={adminOnly ? "/admin/login" : technicianOnly ? "/technician/login" : "/login"} replace />;
  const required = adminOnly ? "admin" : technicianOnly ? "technician" : "user";
  const role = user.role || "user";
  if (role !== required) return <Navigate to={HOME[role] || "/"} replace />;
  return children;
}
